import UI from '../UI'
import GameObject from './GameObject'
import Phaser from 'phaser'
import { CLASS_NAMES, PIXEL_NAME, SCALE } from '../../utils/constants'
import Interactive from './Interactive'
import Player from './Player'

export default class Torch extends GameObject {
  constructor(id, level) {
    super({
      id,
      isRigid: true,
      isBreakable: false,
      isFlat: true,
      isPickable: false,
      isCrushable: false,
      level
    })
    this.isLit = false
    this.light = null
    this.alien = level.scene.add
      .sprite(48, 16)
      .setOrigin(0, 0.5)
      .play("wall_torch_idle");
    this.alien.on(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
      if(this.isLit) {
        if(this.alien.flipX) {
          this.alien.setOrigin(0, 0.5)
        } else {
          this.alien.setOrigin(0.15, 0.5)
        }
        this.alien.setFlipX(!this.alien.flipX)
        this.alien.play("wall_torch_lit")
      }
    });
    this.alien.setScale(SCALE());
    this.strength = 20
    this.leftTrigger = null
    this.rightTrigger = null
  }

  ignite() {
    this.alien.play("wall_torch_lighting")
    this.isLit = true
    this.setUpLights()
  }
  
  async setPosition(coords) {
    super.setPosition(coords)

    this.alien.x = UI.tileToScreen(coords.x);
    this.alien.y = UI.tileToScreen(coords.y);
    
    this.level.onNextTick(() => {
      this.setIgniteTriggers()
    })
  }

  setUpLights() {
    this.light = this.level.scene.lights
      .addLight(UI.tileToScreen(this.position.x), UI.tileToScreen(this.position.y), 1000)
      .setColor(0xe6c8c8)
      .setIntensity(0);
    
    this.level.scene.time.addEvent({
      delay: 100,
      callback: function () {
        if(!this.alien) { return false }
        if(this.light.intensity < 1.5) {
          this.light.setIntensity(this.light.intensity + 0.3)
        }
        Phaser.Geom.Ellipse.Random(
          {x: this.alien.x + UI.tileToPixels(1), y: this.alien.y, width: this.alien.width, height: this.alien.height },
          this.light
        );
      },
      callbackScope: this,
      repeat: -1,
    });
  }

  proximityTrigger(el) {
    if (el.isClass(Player) && el.torch && !this.isLit) {
      this.ignite()
    }
  }

  setIgniteTriggers() {
    const leftNeighbour = this.level.getObjectAt(this.position.x - 1, this.position.y)
    const rightNeighbour = this.level.getObjectAt(this.position.x + 1, this.position.y)
    if(leftNeighbour) {
      const element = new Interactive(PIXEL_NAME.INTERACTION, this)
      element.setPosition(leftNeighbour.position)
      element.overrunBy = this.proximityTrigger.bind(this)
      this.level.interactiveElements[`${element.position.x}-${element.position.y}`] = element
      this.leftTrigger = element
    }
    if(rightNeighbour) {
      const element = new Interactive(PIXEL_NAME.INTERACTION, this)
      element.setPosition(rightNeighbour.position)
      element.overrunBy = this.proximityTrigger.bind(this)
      this.level.interactiveElements[`${element.position.x}-${element.position.y}`] = element
      this.rightTrigger = element
    }
  }

}

Torch.className = CLASS_NAMES.TORCH
